import React from 'react';
import { cn } from '../utils/cn';

export interface ILMSPageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  breadcrumb?: React.ReactNode;
  className?: string;
}

export function ILMSPageHeader({ title, subtitle, actions, breadcrumb, className }: ILMSPageHeaderProps) {
  return (
    <div className={cn('flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3', className)}>
      <div className="min-w-0">
        {breadcrumb && <div className="text-secondary text-ink-500 mb-1">{breadcrumb}</div>}
        <h1 className="text-page-title truncate">{title}</h1>
        {subtitle && <p className="text-secondary text-ink-500 mt-0.5">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap shrink-0">{actions}</div>}
    </div>
  );
}
